import { SerializeHelper } from '../serialize-helper';

class ApiJobWarning {
    constructor(data) {
        /** @type {'input'|'conversion'} */
        this.source = data?.source ?? null;

        /** @type ?String*/
        this.idSource = data?.id_source ?? null;

        /** @type ?Number*/
        this.code = SerializeHelper.getInteger(data?.code);

        /** @type ?String*/
        this.message = data?.message ?? null;

        /** @type ?Object*/
        this.details = data?.details ?? null;
    }

    /**
     * Called by JSON.stringify to get a representation as a serializable object
     *
     * @return {Object}
     */
    toJSON() {
        return {
            source: this.source,
            id_source: this.idSource,
            code: this.code,
            message: this.message,
            details: this.details,
        };
    }
}

export { ApiJobWarning };
